import Vue from "vue";
import App from "./App.vue";
import { ir } from "./check_domain_ir";
import router from "./router";
import store from "@/core/services/store";
import "material-design-icons/iconfont/material-icons.css";
import modal from "@/core/plugins/EasyModal/index";
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
import DataTable from "laravel-vue-datatable";
import ClipboardJS from "clipboard";
// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
//custom
import "./custom";
import { mapGetters } from "vuex";
import moment from "moment-jalaali";
import axios from "axios";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import TerminalTitleRibbon from "./core/plugins/TitleRibbon/install";
import CustomPopup from "./core/plugins/TitleRibbon/plugins/popup/customPopup";
import mobileTable from "./core/plugins/mobileTable/src/install";
Vue.prototype.$sarveLandFront = ir("https://core.terminalads.com/#/login");

const Vue1 = Vue;

Vue.mixin({
  methods: {
    toggleNavigation() {
      this.$store.dispatch("menu/toggle");
    },
    toggleMobileMenu() {
      this.$store.dispatch("menu/toggle");
      // this.$store.dispatch('menu/toggleMobile');
    },

    persian(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/0/gim, "۰");
      str1 = str1.replace(/1/gim, "۱");
      str1 = str1.replace(/2/gim, "۲");
      str1 = str1.replace(/3/gim, "۳");
      str1 = str1.replace(/4/gim, "۴");
      str1 = str1.replace(/5/gim, "۵");
      str1 = str1.replace(/6/gim, "۶");
      str1 = str1.replace(/7/gim, "۷");
      str1 = str1.replace(/8/gim, "۸");
      str1 = str1.replace(/9/gim, "۹");
      return str1;
    },
    english(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/۰/gim, "0");
      str1 = str1.replace(/۱/gim, "1");
      str1 = str1.replace(/۲/gim, "2");
      str1 = str1.replace(/۳/gim, "3");
      str1 = str1.replace(/۴/gim, "4");
      str1 = str1.replace(/۵/gim, "5");
      str1 = str1.replace(/۶/gim, "6");
      str1 = str1.replace(/۷/gim, "7");
      str1 = str1.replace(/۸/gim, "8");
      str1 = str1.replace(/۹/gim, "9");
      return str1;
    },
    price: function (input) {
      try {
        return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } catch (e) {
        return input;
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
    wallet() {
      return this.$store.getters["wallet/wallet"];
    },
  },
});
Vue.config.productionTip = false;

// start filters
Vue.filter("currency", (x) => {
  return x
    ? new Intl.NumberFormat("en-US", { style: "decimal" }).format(x)
    : "-";
});

Vue.filter("timeAgo", (value) => moment(value).fromNow());

Vue.filter("longDate", (value) => moment(value).format("HH:mm jYYYY-jM-jD"));

Vue.filter("rial", (value) =>
  value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
);

Vue.filter("stringDate", function (input) {
  try {
    // let moment = require('moment-jalaali')
    moment.locale("fa", null);
    moment.loadPersian({ dialect: "persian-modern" });
    return moment(input, "YYYY-M-D HH:mm:ss").format("dddd LL HH:mm:ss");
  } catch (e) {}
});

Vue.filter("persianNum", function (input) {
  try {
    if (input === undefined || input == null) return "";
    let str1 = input.toString().trim();
    if (str1 === "") return "";
    str1 = str1.replace(/0/gim, "۰");
    str1 = str1.replace(/1/gim, "۱");
    str1 = str1.replace(/2/gim, "۲");
    str1 = str1.replace(/3/gim, "۳");
    str1 = str1.replace(/4/gim, "۴");
    str1 = str1.replace(/5/gim, "۵");
    str1 = str1.replace(/6/gim, "۶");
    str1 = str1.replace(/7/gim, "۷");
    str1 = str1.replace(/8/gim, "۸");
    str1 = str1.replace(/9/gim, "۹");
    return str1;
  } catch (e) {}
});

Vue.filter("userType", (value) => {
  if (value === "legal") return "شخص حقوقی";
  return "شخص حقیقی";
});

Vue.filter("isEmpty", (val) => {
  return val ? val : "";
});

Vue.filter("serviceType", (val) => {
  if (val === "Payamakland") return "پیامک لند";
  else if (val === "Coreland") return "کورلند";
  else if (val === "Qrland") return "کیوآر لند";
  else if (val === "Robotland") return "ربات لند";
  else if (val === "billboard") return "بیلبورد";
  else if (val === "tablighNegar") return "تبلیغ نگار";
  else return "نامعلوم";
});

Vue.filter("persianNumber", (value) => {
  return value.toPersianLetter();
});

Vue.filter("numericPersianNumber", (value) => {
  if (value < 1_000_000) return value / 1_000 + " هزار";
  return value / 1_000_000 + " میلیون";
});
// end filters

Vue.use(mobileTable);

window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;
window.url = ir(process.env.VUE_APP_URL);
window.VuePersianDatetimePicker = VuePersianDatetimePicker;

export const Axios2 = axios.create({
  baseURL: url,
  timeout: 15000,
  headers: {
    Authorization: localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

export let dataTableProps = {
  tableProps: {
    search: "",
    length: 10,
    column: "id",
    dir: "desc",
    page: 1,
  },
  pagination: {
    align: "right",
    limit: 4,
  },
  translate: {
    nextButton: "بعدی",
    previousButton: "قبلی",
    rowsPerPageText: "تعداد در صفحه",
    noDataText: "داده ای برای نمایش وجود ندارد",
    placeholderSearch: "جستجو کنید..",
  },
};

// // API service init
// ApiService.init();
//
// // Remove this to disable mock API
// MockService.init();
//
// router.beforeEach((to, from, next) => {
//     // Ensure we checked auth before each page load.
//     Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);
//
//     // reset config to initial state
//     store.dispatch(RESET_LAYOUT_CONFIG);
//
//     // Scroll page to top on every route change
//     setTimeout(() => {
//         window.scrollTo(0, 0);
//     }, 100);
// });

Vue.use(DataTable);
Vue.use(CKEditor);
Vue.use(modal);
Vue.component("customPopup", CustomPopup);
Vue.use(VuePersianDatetimePicker, {
  name: "date-picker",
  props: {
    autoSubmit: true,
    clearable: true,
  },
});

// const extra = Axios2.get('user/more').then(res => {
//     return {
//         announcement: res.data.data.advertises,
//         numbers: res.data.data.numbers,
//     };
// });

Vue.use(TerminalTitleRibbon, {
  store,
  axios: Axios2,
  config: () => ({
    dashboardConfig: {
      announcement: {
        img: "/folder-notification-5765801-4841723.png",
        text: "فایل های ثبت شده",
        url: router.resolve({ name: "estate_list" }).href,
      },
      numbers: {
        img: "/folder-notification-5765801-4841723.png",
        text: "فایل های یافت شده",
        url: router.resolve({ name: "recent_list" }).href,
      },
      counter: new Promise((resolve) => {
        resolve({
          announcement: "-",
          numbers: "-",
        });
      }),
    },
    static_top_menu: [],
    header_logo: "/املاک.png",
  }),
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
  permissions: () => store.state.ability,
  core_url: ir(process.env.VUE_APP_CoreLandUrl),
  front_url: ir(process.env.VUE_APP_CoreLandUrlFront),
  sid: 11,
});

$("input[name='table-search']")
  .parent()
  .removeClass("offset-md-6")
  .addClass("ms-auto");

Vue.prototype.can = (value) => {
  const abilities = store.state.ability;

  return (
    abilities.indexOf(value + ":active") >= 0 ||
    abilities.indexOf(value + ":show") >= 0
  );
};

export const Bus = new Vue({
  data() {
    return {};
  },
  methods: {
    setProp(name, value) {
      this[name] = value;
    },
    getProp(name) {
      return this[name];
    },
  },
});

window.Vue = new Vue({
  data() {
    return {
      gotToken: false,
    };
  },
  router,
  store,
  i18n,
  vuetify,
  VuePersianDatetimePicker,
  render: (h) => h(App),
  methods: {
    fetch() {
      let result = null;

      $.ajax({
        url: url + "/user/abilities",
        async: false,
        fn: this.fetch,
        headers: {
          Authorization: Token,
          ACCEPT: "application/json",
        },
        success: (data) => {
          this.permissions();
          this.gotToken = true;
          this.$store.dispatch("global/isLoaded", true);
          this.$store.state.ability = data.data;
          result = data.data;
        },
      });

      return result;
    },
    permissions() {
      Vue.directive("status", (element, binding) => {
        const value = binding.value;
        const abilities = this.$store.state.ability;

        if (
          abilities.indexOf(value + ":active") < 0 &&
          abilities.indexOf(value + ":show") < 0
        ) {
          $(element).remove();
          return;
        }
        if (abilities.indexOf(value + ":show") > -1) {
          $(element).attr("disabled", true);
        }
      });
    },
    permissionRoutes() {
      router.beforeResolve((to, from, next) => {
        const permission = to.meta.permission;
        const abilities = this.gotToken
          ? this.$store.state.ability
          : this.fetch();

        if (process.env.NODE_ENV !== "production") return next();

        if (to.path === "/dashboard") return next();

        if (
          (!Boolean(abilities) ||
            abilities.indexOf(permission + ":active") < 0) &&
          Boolean(permission)
        )
          next(from);

        next();
      });
    },
    getClock() {
      let clock = null;
      $.ajax({
        url: `${url}/setting/clock`,
        type: "GET",
        async: false,
        fn: this.getClock,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (val) => {
          clock = val.data;
        },
      });

      return clock;
    },
    getSpecialmenu() {
      $.ajax({
        url: `${url}/user/menus`,
        type: "GET",
        fn: this.getSpecialmenu,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        success: (data) => {
          this.$store.dispatch("menu/items", data.data);
        },
      });
    },
  },
  mounted() {
    let url = window.location.href;
    const start = url.indexOf("?token=") + "?token=".length;
    const end = url.indexOf("#");
    let token = url.substring(start, end);

    if (start > 6) localStorage.setItem("id_token", token);

    if (localStorage.getItem("id_token"))
      window.Token = localStorage.getItem("id_token");

    this.permissionRoutes();

    if (start > 6) window.history.pushState("dashboard", "Title", "/");

    this.getSpecialmenu();
  },
}).$mount("#app");
